// src/constants/colors.js
export const COLORS = {
  // ===== COULEURS PRINCIPALES =====
  primary: '#286EB6',
  primaryDark: '#2859A8',
  secondary: '#FDB52F',
  secondaryDark: '#FFB226',

  // ===== COULEURS SÉMANTIQUES =====
  success: '#10b981',
  successLight: 'rgba(16, 185, 129, 0.1)',
  danger: '#ef4444',
  dangerLight: 'rgba(239, 68, 68, 0.1)',
  warning: '#f59e0b',
  warningLight: 'rgba(245, 158, 11, 0.1)',
  info: '#3b82f6',
  infoLight: 'rgba(59, 130, 246, 0.1)',

  // ===== COULEURS POUR LES TYPES D'ASSISTANCE =====
  purple: '#8b5cf6',   // pour les cultes
  rose: '#ec4899',     // pour les prières

  // ===== COULEURS POUR LES GRAPHIQUES ET STATISTIQUES =====
  indigo: '#6366f1',
  gray: '#6b7280',
  cyan: '#06b6d4',
  pink: '#ec4899',
  emerald: '#059669',
  amber: '#d97706',
  teal: '#14b8a6',
  sky: '#0ea5e9',
  violet: '#7c3aed',
  fuchsia: '#d946ef',
  orange: '#f59e0b',

  // ===== VERSIONS LIGHT DES COULEURS ÉTENDUES =====
  purpleLight: 'rgba(139, 92, 246, 0.1)',
  roseLight: 'rgba(236, 72, 153, 0.1)',
  indigoLight: 'rgba(99, 102, 241, 0.1)',
  grayLight: 'rgba(107, 114, 128, 0.1)',
  cyanLight: 'rgba(6, 182, 212, 0.1)',
  pinkLight: 'rgba(236, 72, 153, 0.1)',
  emeraldLight: 'rgba(5, 150, 105, 0.1)',
  amberLight: 'rgba(217, 119, 6, 0.1)',
  tealLight: 'rgba(20, 184, 166, 0.1)',
  skyLight: 'rgba(14, 165, 233, 0.1)',
  violetLight: 'rgba(124, 58, 237, 0.1)',
  fuchsiaLight: 'rgba(217, 70, 239, 0.1)',
  orangeLight: 'rgba(245, 158, 11, 0.1)',

  // ===== DÉGRADÉS =====
  gradient: 'linear-gradient(135deg, #1DACCE 0%, #3EA436 100%)',
  gradientBlue: 'linear-gradient(135deg, #1DACCE 0%, #1787a3 100%)',
  gradientGreen: 'linear-gradient(135deg, #3EA436 0%, #2d7a28 100%)',

  // ===== COULEURS NEUTRES =====
  white: '#FFFFFF',
  lightGray: '#F8F9FA',
  dark: '#1E293B',
  textGray: '#64748B'
};